import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ca } from '@cian/analytics';
var getPage = function getPage(pageTypeJK) {
  var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    pageType: 'CardJK',
    siteType: 'desktop',
    extra: _objectSpread({
      PageTypeJK: pageTypeJK
    }, extra)
  };
};
var trackFiltersClick = function trackFiltersClick(_ref) {
  var newbuildingId = _ref.newbuildingId,
    element = _ref.element,
    pageTypeJK = _ref.pageTypeJK,
    isSeoPage = _ref.isSeoPage;
  var extra = {};
  if (isSeoPage) {
    extra.is_seo = true;
  }
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardJK',
    action: 'Click',
    label: element,
    page: getPage(pageTypeJK, extra),
    products: [{
      id: newbuildingId
    }]
  });
};
var trackPolygonClick = function trackPolygonClick(_ref2) {
  var newbuildingId = _ref2.newbuildingId,
    offerId = _ref2.offerId,
    pageTypeJK = _ref2.pageTypeJK,
    isSeoPage = _ref2.isSeoPage;
  var extra = {
    offerId: offerId
  };
  if (isSeoPage) {
    extra.is_seo = true;
  }
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardJK',
    action: 'Click',
    label: 'mvk_apartment_polygon',
    page: getPage(pageTypeJK, extra),
    products: [{
      id: newbuildingId
    }]
  });
};
var trackOfferLinkClick = function trackOfferLinkClick(_ref3) {
  var newbuildingId = _ref3.newbuildingId,
    offerId = _ref3.offerId,
    pageTypeJK = _ref3.pageTypeJK,
    isSeoPage = _ref3.isSeoPage;
  var extra = {
    offerId: offerId
  };
  if (isSeoPage) {
    extra.is_seo = true;
  }
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardJK',
    action: 'Click',
    label: 'mvk_to_appartment',
    page: getPage(pageTypeJK, extra),
    products: [{
      id: newbuildingId
    }]
  });
};
export var tracking = function tracking(newbuildingId, pageTypeJK) {
  var isSeoPage = pageTypeJK === 'Seo';
  var pageType = isSeoPage ? 'Normal' : pageTypeJK;
  var onFilterClick = function onFilterClick(element) {
    return trackFiltersClick({
      newbuildingId: newbuildingId,
      element: element,
      pageTypeJK: pageType,
      isSeoPage: isSeoPage
    });
  };
  var onPolygonClick = function onPolygonClick(offerId) {
    return trackPolygonClick({
      newbuildingId: newbuildingId,
      offerId: offerId,
      pageTypeJK: pageType,
      isSeoPage: isSeoPage
    });
  };
  var onOfferLinkClick = function onOfferLinkClick(offerId) {
    return trackOfferLinkClick({
      newbuildingId: newbuildingId,
      offerId: offerId,
      pageTypeJK: pageType,
      isSeoPage: isSeoPage
    });
  };
  return {
    onFilterClick: onFilterClick,
    onPolygonClick: onPolygonClick,
    onOfferLinkClick: onOfferLinkClick
  };
};